
/** ****************************** Import libs *********************************** */
import { putDataByIdApi,putDataApi } from "./action";

import { URL_CONSTANTS } from "./urls";

export const UsersPutAPI = (id: any, params : any) =>
     putDataByIdApi(URL_CONSTANTS.updateUser, id, params);
export const UserPutstatusAPI = (id: any, params : any) => 
    putDataByIdApi(URL_CONSTANTS.updateStatusUser, id, params);

export const RolePutAPI = (id: any, params : any) => 
    putDataByIdApi(URL_CONSTANTS.getRoles, id, params);
export const RolePutStatusAPI = (id: any, params : any) =>
     putDataByIdApi(URL_CONSTANTS.updateRoleStatus, id, params);

export const NotesErrorPutAPI = (id: any, params : any) => 
    putDataByIdApi(URL_CONSTANTS.updateNotesErrorList, id, params);

export const UpdateCustonNotesTypeAPI = (id: any,params : any) =>
     putDataByIdApi(URL_CONSTANTS.customNotesType,id, params);

export const UpdateLocationMappingAPI = (id: any,params : any) => 
    putDataByIdApi(URL_CONSTANTS.locationMapping,id, params);


// patient mapping api
export const UpdatePatientMappingAPI = (id: any,params : any) =>
     putDataByIdApi(URL_CONSTANTS.mappedPatient,id, params);

// update patient
export const UpdateNotesErrorByPatientDetailsAPI = (id: any,params : any) => 
    putDataByIdApi(URL_CONSTANTS.updateNotesErrorByPatientDetailsById,id,params);

// undo removed notes
export const UndoRemovedNotesAPI = (id: any,params : any) =>
     putDataByIdApi(URL_CONSTANTS.getRemovedNotesList,id,params);

// update notes source details
export const UpdateNotesSourceDetailsAPI = (id: any,params : any) =>
     putDataByIdApi(URL_CONSTANTS.updateNotesSourceDetailsById,id,params);

// update notes source details
export const ReExactNotesAPI = (params : any) => 
    putDataApi(URL_CONSTANTS.reExactNotesList,params);

// update efax
export const UpdateEfaxNumberAPI = (id: any,params : any) => 
    putDataByIdApi(URL_CONSTANTS.efaxCurd,id,params);

// --------------------------------- Auto Delete ---------------------
export const updateAutoDeleteConfig = (id: any, params: any) =>
    putDataByIdApi(URL_CONSTANTS.autoDeleteConfigs, id, params);

export const updateAutoDeleteSchedule = (params: any) =>
    putDataApi(URL_CONSTANTS.autoDeleteSchedule, params);


